import getReduxModuleByFeatureName from '../../utils/redux/getReduxModuleByFeatureName';

const constantsPrefix = 'RANKS';
const statePropName = 'ranks';

const { constants, actions, reducer, selector } = getReduxModuleByFeatureName(constantsPrefix, statePropName);

export { constants, actions, reducer, selector };
